import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Carousel from 'react-slick';
import { headingBlock } from './ContentCarousel.module.scss';

class ContentCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }
  
  render() {
    const { heading, desc, list } = this.props.data;
    const { padding, theme, wrapper } = this.props;
    const settings = {
      customPaging: function(i) {
        function createMarkup() {
          return { __html: list[i].content };
        }
        return (
          <div>
            <Heading Tag="h3" size="SM" bold className="carousel01Heading">
              {list[i].heading}
            </Heading>
            <P Tag="p" size="M" className="carousel01P">
              <span dangerouslySetInnerHTML={createMarkup()}></span>
            </P>
          </div>
        );
      },
      className: 'carousel01',
      dots: true,
      dotsClass: "carousel01Item",
      fade: true,
      speed: 500,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
    };
    
    return (
      <>
        <Section padding={padding} theme={theme}>
          <Wrapper size={wrapper}>
            <div className={headingBlock}>
              <div>
                <Heading Tag="h2" size="SL" marginBottom="Xxs" bold>{heading}</Heading>
                <P>{desc}</P>
              </div>
              <div></div>
            </div>
            <Carousel
              asNavFor={this.state.nav2}
              ref={slider => (this.slider1 = slider)}
              {...settings}
            >
              {list.map((item, i) => (
                <div key={i}>
                  <img src={item.img.publicURL} alt={item.heading} />
                </div>
              ))}
            </Carousel>
          </Wrapper>
        </Section>
      </>
    );
  }
}

ContentCarousel.propTypes = {
  data: PropTypes.object.isRequired,
  padding: PropTypes.string,
  theme: PropTypes.string,
  wrapper: PropTypes.string,
};
ContentCarousel.defaultProps = {
  padding: 'M',
  theme: null,
  wrapper: 'ML'
}

export default ContentCarousel;
